// Update swym wishlist button in the main product form
document.addEventListener('variant:changed', function(event) {
  const form = event.target;
  const wishlistBtn = form.querySelector('.wishlist-btn');

  if(wishlistBtn) {
    if(!window.SwymCallbacks) return;

    window.SwymCallbacks[0]();
  };
});
